/** Shared financial accents for Accountant and client financial reports. */
export const accountingPalette = {
	positive: { foreground: "#157347", background: "#f0faf4", separator: "#cfe4d8" },
	negative: { foreground: "#b42332", background: "#fff1f3", separator: "#efd1d8" },
	reserve: { foreground: "#8553b6", background: "#f7f0fc", separator: "#e0d2ec" },
	released: { foreground: "#167ca6", background: "#eef9ff", separator: "#cce3ef" },
	neutral: { foreground: "#475467", background: "#f8fafc", separator: "#e1e6ef" },
	pending: { foreground: "#925f00", background: "#fff4e5", separator: "#edddc4" },
} as const;
